import createReactContext from '@ant-design/create-react-context';
var FormContext = createReactContext({
  labelAlign: 'right',
  vertical: false
});
export default FormContext;
//# sourceMappingURL=context.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/form/context.js
// module id = 324
// module chunks = 0